'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Subtitle = exports.Title = exports.P = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _templateObject = _taggedTemplateLiteral(['\n  // color: ', ';\n'], ['\n  // color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 1.3em;\n  font-weight:', ';\n  color: ', ';\n  '], ['\n  font-size: 1.3em;\n  font-weight:', ';\n  color: ', ';\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight:', ';\n  ', '\n  '], ['\n  color: ', ';\n  font-weight:', ';\n  ', '\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: ', ';\n  ', '\n  '], ['\n  color: ', ';\n  font-weight: ', ';\n  ', '\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: ', ';\n  ', '\n'], ['\n  color: ', ';\n  font-weight: ', ';\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _dompurify = require('dompurify');

var _dompurify2 = _interopRequireDefault(_dompurify);

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var P = exports.P = function P(_ref) {
  var children = _ref.children;
  var sanitizer = _dompurify2.default.sanitize;
  children = (typeof children === 'undefined' ? 'undefined' : _typeof(children)) === 'object' ? children.join('') : children;
  return _react2.default.createElement('p', {
    dangerouslySetInnerHTML: {
      __html: sanitizer(children.replace(/\n/g, '<br/>'))
    }
  });
};

var Title = exports.Title = _styledComponents2.default.h1(_templateObject, function (_ref2) {
  var theme = _ref2.theme;
  return (0, _chromaJs2.default)(theme.textColor).brighten(1);
});

var Subtitle = exports.Subtitle = _styledComponents2.default.h2(_templateObject2, function (props) {
  return props.bold ? '700' : '500';
}, function (_ref3) {
  var theme = _ref3.theme;
  return (0, _chromaJs2.default)(theme.textColor).brighten(1);
});

var H1 = exports.H1 = _styledComponents2.default.h1(_templateObject3, function (_ref4) {
  var theme = _ref4.theme;
  return (0, _chromaJs2.default)(theme.textColor).brighten(1);
}, function (props) {
  return props.bold ? '700' : '500';
}, function (props) {
  return props.style;
});

var H2 = exports.H2 = _styledComponents2.default.h2(_templateObject4, function (_ref5) {
  var theme = _ref5.theme;
  return (0, _chromaJs2.default)(theme.textColor).brighten(1);
}, function (props) {
  return props.bold ? '700' : '500';
}, function (props) {
  return props.style;
});

var H3 = exports.H3 = _styledComponents2.default.h3(_templateObject4, function (_ref6) {
  var theme = _ref6.theme;
  return (0, _chromaJs2.default)(theme.textColor).brighten(1);
}, function (props) {
  return props.bold ? '700' : '500';
}, function (props) {
  return props.style;
});

var H4 = exports.H4 = _styledComponents2.default.h4(_templateObject4, function (_ref7) {
  var theme = _ref7.theme;
  return (0, _chromaJs2.default)(theme.textColor).brighten(1);
}, function (props) {
  return props.bold ? '700' : '500';
}, function (props) {
  return props.style;
});

var H5 = exports.H5 = _styledComponents2.default.h5(_templateObject5, function (_ref8) {
  var theme = _ref8.theme;
  return (0, _chromaJs2.default)(theme.textColor).brighten(1);
}, function (props) {
  return props.bold ? '700' : '500';
}, function (props) {
  return props.style;
});